<template>
  <v-container>
    <div class="mb-2">
      <div style="overflow-x: auto; white-space: nowrap">
        <v-btn
          class="ma-0 mr-1 mb-1"
          depressed
          :outline="currentFilter != 'today'"
          :color="currentFilter == 'today' ? 'primary' : 'grey'"
          small
          @click="changeDate('today')"
          >{{ $t('today') }}</v-btn
        >
        <v-btn
          class="ma-0 mr-1 mb-1"
          depressed
          :outline="currentFilter != 'this_month'"
          :color="currentFilter == 'this_month' ? 'primary' : 'grey'"
          small
          @click="changeDate('this_month')"
          >{{ $t('this month') }}</v-btn
        >
        <v-btn
          class="ma-0 mr-1 mb-1"
          depressed
          :outline="currentFilter != 'this_year'"
          :color="currentFilter == 'this_year' ? 'primary' : 'grey'"
          small
          @click="changeDate('this_year')"
          >{{ $t('this year') }}</v-btn
        >
        <v-btn
          class="ma-0 mr-1 mb-1"
          depressed
          :outline="currentFilter != 'last_month'"
          :color="currentFilter == 'last_month' ? 'primary' : 'grey'"
          small
          @click="changeDate('last_month')"
          >{{ $t('last 30 days') }}</v-btn
        >
        <v-btn
          class="ma-0 mr-1 mb-1"
          depressed
          :outline="currentFilter != 'last_365_day'"
          :color="currentFilter == 'last_365_day' ? 'primary' : 'grey'"
          small
          @click="changeDate('last_365_day')"
          >{{ $t('last 365 days') }}</v-btn
        >
        <v-btn
          class="ma-0 mr-1 mb-1"
          depressed
          :outline="currentFilter != 'custom_date'"
          :color="currentFilter == 'custom_date' ? 'primary' : 'grey'"
          small
          @click="changeDate('custom_date')"
          >{{ $t('Custom Date') }}</v-btn
        >
      </div>
      <v-layout
        wrap
        class="mt-2"
        v-if="currentFilter == 'custom_date' || currentFilter == 'custom_time'"
      >
        <v-flex xs12 sm6>
          <span class="order_summary_datepicker">{{ $t('from') }}:</span>
          <v-layout wrap row class="mb-2">
            <v-flex xs8 class="form-control">
              <datepicker v-model="selectedDate.start" @selected="onSelectedStartDate"></datepicker>
            </v-flex>
            <v-flex xs4 class="form-control">
              <v-dialog
                ref="starttime"
                v-model="showStartTimeDialog"
                :return-value.sync="starttime"
                persistent
                lazy
                full-width
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <div class="pl-2 pr-2">
                    <input type="text" readonly v-on="on" placeholder="00:00" v-model="starttime" />
                  </div>
                </template>
                <v-time-picker v-if="showStartTimeDialog" v-model="starttime" full-width>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="showStartTimeDialog = false">{{
                    $t('cancel')
                  }}</v-btn>
                  <v-btn
                    flat
                    color="primary"
                    @click="
                      $refs.starttime.save(starttime)
                      showStartTimeDialog = false
                      changeDate('custom_time')
                    "
                    >{{ $t('Confirm') }}</v-btn
                  >
                </v-time-picker>
              </v-dialog>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs12 sm6>
          <span class="order_summary_datepicker" style="margin-bottom: 10px;">{{ $t('to') }}:</span>
          <v-layout wrap row class="mb-2">
            <v-flex xs8 class="form-control">
              <datepicker
                v-model="selectedDate.end"
                style
                @selected="onSelectedEndDate"
              ></datepicker>
            </v-flex>
            <v-flex xs4 class="form-control">
              <v-dialog
                ref="endtime"
                v-model="showEndTimeDialog"
                :return-value.sync="endtime"
                persistent
                lazy
                full-width
                width="290px"
              >
                <template v-slot:activator="{ on }">
                  <div class="pl-2 pr-2">
                    <input type="text" readonly v-on="on" placeholder="00:00" v-model="endtime" />
                  </div>
                </template>
                <v-time-picker v-if="showEndTimeDialog" v-model="endtime" full-width>
                  <v-spacer></v-spacer>
                  <v-btn flat color="primary" @click="showEndTimeDialog = false">{{
                    $t('cancel')
                  }}</v-btn>
                  <v-btn
                    flat
                    color="primary"
                    @click="
                      $refs.endtime.save(endtime)
                      showEndTimeDialog = false
                      changeDate('custom_time')
                    "
                    >{{ $t('Confirm') }}</v-btn
                  >
                </v-time-picker>
              </v-dialog>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>

    <v-divider class="mt-3 mb-3"></v-divider>

    <v-layout wrap>
      <v-flex xs12 sm8>
        <div class="nav nav-tabs" style="margin-bottom:15px; overflow-x: auto; white-space: nowrap">
          <v-btn
            small
            depressed
            class="ma-1"
            @click="changeStatus('all')"
            :outline="filterStatus != 'all'"
            :color="filterStatus != 'all' ? 'grey' : 'primary'"
            >{{ $t('All') }} {{ badge.all > 0 ? '(' + badge.all + ')' : '' }}</v-btn
          >
          <v-btn
            small
            depressed
            class="ma-1"
            @click="changeStatus('ordered')"
            :outline="filterStatus != 'ordered'"
            :color="filterStatus != 'ordered' ? 'grey' : 'primary'"
            >{{ $t('ordered') }} {{ badge.ordered > 0 ? '(' + badge.ordered + ')' : '' }}</v-btn
          >
          <v-btn
            small
            depressed
            class="ma-1"
            @click="changeStatus('paid')"
            :outline="filterStatus != 'paid'"
            :color="filterStatus != 'paid' ? 'grey' : 'primary'"
            >{{ $t('paid') }} {{ badge.paid > 0 ? '(' + badge.paid + ')' : '' }}</v-btn
          >
          <v-btn
            small
            depressed
            class="ma-1"
            @click="changeStatus('shipped')"
            :outline="filterStatus != 'shipped'"
            :color="filterStatus != 'shipped' ? 'grey' : 'primary'"
            >{{ $t('shipped') }} {{ badge.shipped > 0 ? '(' + badge.shipped + ')' : '' }}</v-btn
          >
          <v-btn
            small
            depressed
            class="ma-1"
            @click="changeStatus('canceled')"
            :outline="filterStatus != 'canceled'"
            :color="filterStatus != 'canceled' ? 'grey' : 'primary'"
            >{{ $t('cancel') }} {{ badge.canceled > 0 ? '(' + badge.canceled + ')' : '' }}</v-btn
          >
        </div>
      </v-flex>
      <v-flex xs12 sm4 class="text-xs-right">
        <v-layout justify-end>
          <v-btn outline color="grey" @click="exportOrderSummary" class="mr-0">
            <i class="fas fa-file-export mr-1"></i>
            {{ $t('export') }}
          </v-btn>

          <v-btn
            fab
            outline
            color="primary"
            @click="getOrderSummary()"
            v-tooltip.top="$t('Refresh')"
            small
          >
            <i class="fa fa-refresh"></i>
          </v-btn>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-data-table :headers="headers" :items="filterSummary" class="elevation-1">
      <template v-slot:items="props">
        <bearhouse-order-item v-model="props.item"></bearhouse-order-item>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import datepicker from 'vuejs-datepicker'
import api from '@/api'
import moment from 'moment'
import numeral from 'numeral'

import { bearhouseset } from '@/bearhouse.js'
import BearhouseOrderItem from './BearhouseOrderItem'
import XLSX from 'xlsx'

export default {
  data() {
    return {
      headers: [
        { text: 'Order No.', value: 'id' },
        { text: 'Products', sortable: false },
        { text: 'ชานมบ้านหมีหน้าร้าน', value: 'ชานมบ้านหมีหน้าร้าน' },
        { text: 'ช็อกโกแลตบ้านหมี', value: 'ช็อกโกแลตบ้านหมี' },
        { text: 'ชาไทยบ้านหมีปักษ์ใต้', value: 'ชาไทยบ้านหมีปักษ์ใต้' },
        { text: 'ไข่มุกบุกคาราเมลไหม้', value: 'ไข่มุกบุกคาราเมลไหม้' },
        { text: 'โมจิโรลนมฮอกไกโด', value: 'โมจิโรลนมฮอกไกโด' },
        { text: 'โมจิโรลช็อกโกแลต ', value: 'โมจิโรลช็อกโกแลต' },
        { text: 'โมจิโรลฝอยทองบ้านหมี', value: 'โมจิโรลฝอยทองบ้านหมี' },
        { text: 'นมน้ำตาลแดงบ้านหมี ', value: 'นมน้ำตาลแดงบ้านหมี' },
        { text: 'แป้งไข่มุกโมจิบ้านหมี D.I.Y', value: 'แป้งไข่มุกโมจิบ้านหมี D.I.Y' },
        { text: this.$t('Remark'), value: 'remark' }
      ],
      desserts: [],
      shippingFilter: [],
      shippingOptions: [],
      cbAll: [],
      checkboxAll: false,
      pageNumber: 1,
      size: 10,
      search: '',
      filterStatus: 'all',
      showStartTimeDialog: false,
      showEndTimeDialog: false,
      starttime: '00:00',
      endtime: '23:59',
      selectedDate: {
        start: moment()
          .startOf('month')
          .toDate(),
        end: moment()
          .endOf('month')
          .toDate()
      },
      summary: [],
      lang: {
        days: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        months: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec'
        ],
        pickers: ['next 7 days', 'next 30 days', 'previous 7 days', 'previous 30 days'],
        placeholder: {
          date: 'Select Date',
          dateRange: 'Select Date Range'
        }
      },
      currentFilter: 'this_month',
      badge: {
        all: 0,
        canceled: 0,
        ordered: 0,
        paid: 0,
        shipped: 0
      },
      status: '',
      orderStatusOptions: [
        {
          label: this.$t('ordered'),
          value: 'ordered'
        },
        {
          label: this.$t('paid'),
          value: 'paid'
        },
        {
          label: this.$t('shipped'),
          value: 'shipped'
        },
        {
          label: this.$t('cancel'),
          value: 'canceled'
        }
      ]
    }
  },
  components: {
    datepicker,
    BearhouseOrderItem
    // PrintAllCovers
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      products: 'getProducts',
      loadingProduct: 'getLoadingProduct'
    }),
    pageCount: function() {
      let l = this.badge[this.filterStatus]
      let s = this.size
      return Math.ceil(l / s)
    },
    filterSummary: function() {
      let vm = this
      let orders = []
      let filter = []
      if (vm.search == '') {
        filter = vm.desserts
      } else {
        filter = vm.desserts.filter(function(el) {
          return (
            el.first_name.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.last_name.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.id.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.productdetail.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.nameaddress.toLowerCase().includes(vm.search.toLowerCase())
          )
        })
      }

      if (vm.shippingFilter.length) {
        filter = filter.filter(el => {
          return vm.shippingFilter.some(v => el.shippingtype == v.value)
        })
      }

      vm.badge = {
        all: 0,
        canceled: 0,
        ordered: 0,
        paid: 0,
        shipped: 0
      }
      vm.badge.all = filter.length

      $.each(filter, function(index, val) {
        vm.badge[val.status] += 1
        if (val.status == vm.filterStatus) {
          orders.push(val)
        } else if (vm.filterStatus == 'all') {
          orders.push(val)
        }
      })

      const start = (this.pageNumber - 1) * this.size
      const end = start + this.size
      return orders.slice(start, end)
    },
    filterOrders: function() {
      let vm = this
      let orders = this.desserts
      if (vm.filterStatus !== 'all') {
        orders = this.desserts.filter(el => el.status == vm.filterStatus)
      }

      return orders
    }
  },
  async mounted() {
    await this.$store.dispatch('loadProducts')
    this.getOrderSummary()
  },
  methods: {
    getOrderSummary: function() {
      let vm = this
      let data = {
        pageid: vm.selectedBot.pageid,
        datefrom:
          moment(vm.selectedDate.start).format('YYYY-MM-DD') +
          (vm.starttime != null ? ' ' + vm.starttime : ''),
        dateto:
          moment(vm.selectedDate.end).format('YYYY-MM-DD') +
          (vm.endtime != null ? ' ' + vm.endtime : ''),
        status: vm.filterStatus
      }
      // vm.$store.dispatch('loading')
      api.getOrderSummary(data, function(error, response) {
        if (error) {
          console.error(error)
          // vm.$store.dispatch('loading')
          return
        }
        if (response.data) {
          vm.summary = response.data
          var data = []
          response.data.map(el => {
            var record = el
            var productdetail = []
            record['ชานมบ้านหมีหน้าร้าน'] = 0
            record['ช็อกโกแลตบ้านหมี'] = 0
            record['ชาไทยบ้านหมีปักษ์ใต้'] = 0
            record['ไข่มุกบุกคาราเมลไหม้'] = 0
            record['โมจิโรลนมฮอกไกโด'] = 0
            record['โมจิโรลช็อกโกแลต'] = 0
            record['โมจิโรลฝอยทองบ้านหมี'] = 0
            record['นมน้ำตาลแดงบ้านหมี'] = 0
            record['แป้งไข่มุกโมจิบ้านหมี D.I.Y'] = 0

            try {
              var productlist = JSON.parse(record.productdetail)

              productlist.map(product => {
                if (bearhouseset.hasOwnProperty(product.name)) {
                  var set = bearhouseset[product.name]
                  set.map(pid => {
                    var p = vm.products.find(el => {
                      return el.id == pid
                    })
                    if (p) {
                      var photo = p.photourl.split(',')
                      let pIndex = productdetail.findIndex(pd => {
                        return pd.name == p.name
                      })
                      if (pIndex > -1) {
                        productdetail[pIndex].quantity += 1
                      } else {
                        productdetail.push({
                          name: p.name,
                          quantity: 1,
                          option: p.productstock.length > 0 ? p.productstock[0][1] : '',
                          sku: p.productstock.length > 0 ? p.productstock[0][5] : '',
                          price: p.productstock.length > 0 ? p.productstock[0][4] : p.discountprice,
                          photourl: photo.length > 0 ? photo[0] : ''
                        })
                      }
                    }
                  })
                } else {
                  let pIndex = productdetail.findIndex(pd => {
                    return pd.name == product.name
                  })
                  if (pIndex > -1) {
                    productdetail[pIndex].quantity += 1
                  } else {
                    productdetail.push(product)
                  }
                }
              })
            } catch (error) {
              console.error(error)
              productdetail = record.productdetail
            }

            if (typeof productdetail === 'object') {
              productdetail.map(p => {
                if (record.hasOwnProperty(p.name)) {
                  record[p.name] = p.quantity
                }
              })
            }

            record.productlist = productdetail
            //   {"name":"โมจิโรลนมฮอกไกโด","quantity":"1","option":"Normal","sku":"","price":"120","photourl" : "https://d25bondvihbdz.cloudfront.net/ecommerce/1586108442478S__87241566.jpg"}
            data.push(record)
          })

          vm.desserts = data

          //    { text: 'Order No.', value: '' },
          // { text: 'Products', value: '' },
          // { text: 'ชานมบ้านหมี', value: '' },
          // { text: 'ชาไทยบ้านหมีปักษ์ใต้', value: '' },
          // { text: 'ช็อคโกแลตบ้านหมี', value: '' },
          // { text: 'นมน้ำตาลแดงบ้านหมี', value: '' },
          // { text: 'ไข่มุกขุกคาราเมลไหม้', value: '' },
          // { text: 'โมจิโรลนมฮอกไกโด ', value: '' },
          // { text: 'โมจิโรลช็อคโกแลต', value: '' },
          // { text: 'โมจิโรลฝอยทอง ', value: '' },
          // { text: 'remark', value: '' }

          if (vm.filterStatus == 'all') {
            vm.badge = {
              all: response.all,
              canceled: response.canceled,
              ordered: response.ordered,
              paid: response.paid,
              shipped: response.shipped
            }
          }
        }
        // vm.$store.dispatch('loading')
      })
    },
    changeStatus: function(value) {
      this.filterStatus = value
      this.pageNumber = 1
    },
    exportOrderSummary: function(type) {
      let vm = this
      let header = 'data:text/csv;charset=utf-8,%EF%BB%BF'
      let csvContent = ''
      let orders = []
      let filter = []
      if (vm.search == '') {
        filter = vm.desserts
      } else {
        filter = vm.desserts.filter(function(el) {
          return (
            el.first_name.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.last_name.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.id.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.productdetail.toLowerCase().includes(vm.search.toLowerCase()) ||
            el.nameaddress.toLowerCase().includes(vm.search.toLowerCase())
          )
        })
      }

      $.each(filter, function(index, val) {
        if (val.status == vm.filterStatus) {
          orders.push(val)
        } else if (vm.filterStatus == 'all') {
          orders.push(val)
        }
      })

      var json = []
      orders.map(val => {
        let productlist = ''
        val.productlist.map(p => {
          productlist +=
            p.name +
            ' x ' +
            p.quantity +
            ` SKU:${p.sku ? p.sku : '- '}` +
            (p.option ? ' (' + p.option + ')' : '') +
            ' : ' +
            (p.price > 0 ? '฿' + p.price : 'Free') +
            '\r\n'
        })
        json.push({
          orderno: val.id,
          products: productlist,
          ชานมบ้านหมีหน้าร้าน: val['ชานมบ้านหมีหน้าร้าน'],
          ช็อกโกแลตบ้านหมี: val['ช็อกโกแลตบ้านหมี'],
          ชาไทยบ้านหมีปักษ์ใต้: val['ชาไทยบ้านหมีปักษ์ใต้'],
          ไข่มุกบุกคาราเมลไหม้: val['ไข่มุกบุกคาราเมลไหม้'],
          โมจิโรลนมฮอกไกโด: val['โมจิโรลนมฮอกไกโด'],
          โมจิโรลช็อกโกแลต: val['โมจิโรลช็อกโกแลต'],
          โมจิโรลฝอยทองบ้านหมี: val['โมจิโรลฝอยทองบ้านหมี'],
          นมน้ำตาลแดงบ้านหมี: val['นมน้ำตาลแดงบ้านหมี'],
          'แป้งไข่มุกโมจิบ้านหมี D.I.Y': val['แป้งไข่มุกโมจิบ้านหมี D.I.Y'],
          remark: val.remark
        })
      })

      const dataWS = XLSX.utils.json_to_sheet(json)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, dataWS)
      XLSX.writeFile(wb, 'export.xlsx')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/BearhouseOrder2.vue